// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.manage-inventory {
  margin-bottom: 40px;
  padding-left: 100px !important;
}
.manage-inventory .alert {
  border-radius: 8px;
}
.manage-inventory .alert div:first-child {
  border-radius: 8px 0 0 8px;
}
.manage-inventory .mediaStop {
  height: 140px;
  width: 251px;
  margin-bottom: 20px;
}
.manage-inventory .accordion {
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 60px;
}
.manage-inventory .ctn-alert .alert {
  margin: 0 30px 30px;
}
.manage-inventory .not-eligible-container {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d2d2d2;
  width: calc(33.33% - 14px);
  margin-bottom: 20px;
}
.manage-inventory .not-eligible-container .bottom-container {
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  background-color: hsl(0, 0%, 95%);
  border-top: 1px solid #d2d2d2;
  padding: 20px;
  width: 100%;
}
.manage-inventory .not-eligible-container .top-container {
  padding: 20px;
}
@media (max-width: 1024px) {
  .manage-inventory .accordion {
    margin-bottom: 30px;
  }
  .manage-inventory .not-eligible-container {
    width: 100%;
  }
  .manage-inventory .fans-list .fans-list-container {
    margin: 0 20px 20px 0 !important;
  }
}
.manage-inventory h1 {
  margin: 32px 0;
  font-size: 40px;
  font-family: "Omnes-ATT-W02-Light";
}
@media (max-width: 1024px) {
  .manage-inventory h1 {
    font-size: 25px;
  }
}
.manage-inventory h2 {
  margin: 32px 0;
  font-family: "Omnes-ATT-W02" !important;
}
.manage-inventory .fontsize {
  font-size: 30px !important;
}
@media (max-width: 1024px) {
  .manage-inventory h1 {
    margin: 25px 0;
    margin-top: 70px;
  }
}
.manage-inventory .alert {
  margin: -10px 0 30px;
}
.manage-inventory .alert .close {
  cursor: pointer;
}
.manage-inventory .panel {
  min-height: 280px;
  padding: 20px 0;
  position: relative;
}
.manage-inventory .page-error {
  margin-top: 20px;
}
.manage-inventory .flex-container {
  border-right: 1px solid #d2d2d2;
  display: flex;
  float: left;
}
.manage-inventory .nav-container-inventory {
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  display: inline-block;
  position: absolute;
  top: 50%;
  width: calc(100% - 471px);
}
.manage-inventory .link-button {
  font-family: "Omnes-ATT-W02";
}
.manage-inventory .chart-container {
  text-align: center;
}
.manage-inventory .chart-legend-container {
  margin-left: 15px;
  width: 250px;
}
.manage-inventory .cancel-participation-link {
  padding-top: 14px;
  text-align: center;
}
.manage-inventory .chart-legends {
  margin-left: 15px;
  width: 250px;
}
.manage-inventory .chart-legends .legend-container {
  margin-top: 0;
}
.manage-inventory .chart-legends .legend-container li {
  padding-bottom: 3px;
}
.manage-inventory .apple-cert {
  margin-right: 48px;
  margin-top: -2px;
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 82px;
}
.manage-inventory .apple-cert i {
  display: table-cell;
  font-size: 25px;
  padding-right: 5px;
}
.manage-inventory .apple-cert a {
  display: table-cell;
}
.manage-inventory .apple-cert .icon-alert {
  padding-right: 10px;
}
.manage-inventory .nav-icons {
  margin-left: 96px;
  margin-right: 96px;
}
.manage-inventory .nav-icons li {
  display: inline-block;
  text-align: center;
  vertical-align: top;
  width: calc(50% - 58px);
}
.manage-inventory .nav-icons li i {
  font-size: 50px;
}
.manage-inventory .nav-icons li figure {
  margin: 10px 0;
}
.manage-inventory .nav-icons li:nth-child(odd) {
  margin-right: 74px;
}
.manage-inventory .nav-icons li:nth-child(1) {
  margin-bottom: 20px;
}
.manage-inventory .nav-icons li:nth-child(2) {
  margin-bottom: 20px;
}
.manage-inventory img {
  width: 50px;
  height: 50px;
}
.manage-inventory .addAccountBtn {
  width: 89%;
  margin-top: 13%;
  padding: 10px 16px 10px 20px;
  font: 16px "Omnes-ATT-W02", Arial;
  background-color: #0670B7;
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.0588235294);
  color: #FCFCFC;
  letter-spacing: 0.53px;
}
.manage-inventory .addAccountBtnDisabled {
  width: 89%;
  margin-top: 13%;
  padding: 10px 16px 10px 20px;
  font: 16px "Omnes-ATT-W02", Arial;
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.0588235294);
  letter-spacing: 0.53px;
  background: #d2d2d2;
  cursor: not-allowed;
  color: #767676;
}
.manage-inventory .removeAccount {
  font: 16px "Omnes-ATT-W02", Arial;
}
@media screen and (min-width: 1025px) {
  .manage-inventory .cancel-participation-link {
    margin-right: 10%;
  }
  .manage-inventory li {
    margin-right: 36px;
    width: 220px;
  }
  .manage-inventory .chart-container {
    margin: 0 20px;
  }
}
@media screen and (max-width: 1025px) and (min-width: 300px) {
  .manage-inventory .manage-inventory {
    margin-bottom: 40px;
    padding-left: 11px !important;
  }
  .manage-inventory .addAccountBtn {
    width: 98%;
    margin-top: 0;
    margin-left: 1%;
  }
  .manage-inventory .cancel-participation-link {
    margin-left: 1%;
  }
  .manage-inventory li {
    margin-left: 1%;
    width: 100%;
  }
  .manage-inventory .chart-container {
    margin: 0 20px;
  }
}
@media screen and (max-width: 300px) {
  .manage-inventory .addAccountBtn {
    width: 98%;
    margin-top: 0;
    margin-left: 1%;
  }
  .manage-inventory .cancel-participation-link {
    margin-left: 1%;
  }
  .manage-inventory li {
    margin-left: 1%;
    width: 100%;
  }
}
.manage-inventory .iconNI, .manage-inventory .iconE, .manage-inventory .iconP, .manage-inventory .iconI {
  margin: 0;
}
.manage-inventory .iconNI {
  color: #ffb81e;
}
.manage-inventory .iconE {
  color: #cf2a2a;
}
.manage-inventory .iconP, .manage-inventory .iconI {
  color: #007a3e;
}
.manage-inventory .component-container {
  margin-right: -1px;
  padding-top: 20px;
}
.manage-inventory .fans-list:nth-child(2n) .fans-list-container {
  margin: 0 20px 20px 0 !important;
}
.manage-inventory .fans-list:nth-child(1n) .fans-list-container {
  margin: 0 20px 20px 0 !important;
}
.manage-inventory .fans-list:nth-child(3n) .fans-list-container {
  margin: 0 20px 0 0;
  margin-right: 0 !important;
}
.manage-inventory .search-fans {
  float: right;
  padding-left: 0;
  padding-right: 0;
  position: relative;
  width: calc(33.33% - 10px);
}
.manage-inventory .search-fans input {
  padding-right: 40px;
}
.manage-inventory .search-fans .search-icon {
  margin-top: -10px;
  position: absolute;
  right: 5px;
  top: 50%;
}
.manage-inventory .search-fans .search-icon i {
  color: #c4c4c4;
  cursor: pointer;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.manage-inventory .pagination-position {
  margin: auto;
  padding: 10px 10px 20px;
  width: 640px;
}
.manage-inventory .search-input {
  position: relative;
}
.manage-inventory .clear-search {
  float: right;
  padding-top: 10px;
}
.manage-inventory .no-result {
  border-radius: 8px;
  background: white;
  border: 1px solid #d1d1d1;
  float: left;
  margin: 0 20px 20px 0;
  /* min-height: 355px; */
  padding: 20px;
  position: relative;
  display: block;
  width: calc(33.33% - 14px);
}
.manage-inventory .disable-link {
  pointer-events: none !important;
}
@media (max-width: 1024px) {
  .manage-inventory .alert {
    margin: -10px 0px 20px;
  }
  .manage-inventory .alert div:nth-child(2) {
    padding-right: 30px;
  }
  .manage-inventory .panel {
    padding: 20px 10px;
  }
  .manage-inventory .flex-container {
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    border-right: 0;
    flex-direction: column;
    float: none;
    width: 100%;
  }
  .manage-inventory .chart-legend-container {
    margin-left: 0;
    width: 100%;
  }
  .manage-inventory .chart-legend-container .legend-container {
    min-height: auto;
    margin-bottom: 6%;
    margin-top: 6%;
  }
  .manage-inventory .chart-legend-container .legend-container ul {
    margin: auto;
  }
  .manage-inventory .chart-legend-container .legend-container li {
    display: inline-block;
  }
  .manage-inventory .cancel-participation-link {
    padding-bottom: 20px;
  }
  .manage-inventory .apple-cert {
    margin: auto;
    padding-bottom: 20px;
    padding-top: 0px;
    width: 260px;
    min-height: 69px;
  }
  .manage-inventory .nav-container-inventory {
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    display: block;
    padding-top: 20px;
    position: relative;
    width: 100%;
  }
  .manage-inventory .nav-icons {
    margin: 0;
  }
  .manage-inventory .nav-icons li {
    vertical-align: top;
    width: calc(50% - 39px);
  }
  .manage-inventory .nav-icons li:nth-child(odd) {
    margin-right: 40px;
  }
  .manage-inventory .component-container {
    margin-right: 0;
  }
  .manage-inventory .cancel-participation-link {
    display: block;
    text-align: center;
    border-bottom: 1px solid #d2d2d2;
    padding: 20px 0;
  }
  .manage-inventory .search-fans {
    float: none;
    margin-top: 20px;
    width: auto;
  }
  .manage-inventory .clear-search {
    float: none;
  }
  .manage-inventory .pagination-position {
    width: auto;
  }
}

@media screen and (max-width: 1025px) and (min-width: 300px) {
  .manage-inventory {
    margin-bottom: 40px;
    padding-left: 11px !important;
    margin-top: 40px;
    padding-right: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-inventory/manage-inventory.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EAEE,mBAAA;EACA,8BAAA;AAkJF;AA/IE;EACE,kBAAA;AAiJJ;AA/IA;EACI,0BAAA;AAiJJ;AA/IE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAiJJ;AA9II;EACE,gCAAA;EACA,mBAAA;AAgJN;AA5II;EACE,mBAAA;AA8IN;AA1IE;EFKE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEHA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;AAgJJ;AA9II;EFFA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEIE,iCAAA;EACA,6BAAA;EACA,aAAA;EACA,WAAA;AAoJN;AAlJI;EACE,aAAA;AAoJN;AF1KI;EE4BA;IACE,mBAAA;EAiJJ;EA9IE;IACE,WAAA;EAgJJ;EA7II;IACE,gCAAA;EA+IN;AACF;AA5IE;EACE,cAAA;EACA,eAAA;EACA,kCAAA;AA8IJ;AF1LI;EEyCF;IAKI,eAAA;EAgJJ;AACF;AA9IE;EACE,cAAA;EACA,uCAAA;AAgJJ;AA7IE;EACE,0BAAA;AA+IJ;AFtMI;EE4DF;IACE,cAAA;IACA,gBAAA;EA6IF;AACF;AA1IE;EACE,oBAAA;AA4IJ;AA1II;EACE,eAAA;AA4IN;AAxIE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AA0IJ;AAtIA;EACE,gBAAA;AAwIF;AArIA;EAGE,+BAAA;EAEA,aAAA;EACA,WAAA;AAqIF;AAhIA;EFpFI,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EEsFF,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;AAsIF;AAnIA;EACE,4BAAA;AAqIF;AAnIA;EAEE,kBAAA;AAoIF;AAjIA;EACE,iBAAA;EACA,YAAA;AAmIF;AA9HA;EACE,iBAAA;EACA,kBAAA;AAgIF;AA7HA;EACE,iBAAA;EACA,YAAA;AA+HF;AA7HI;EACE,aAAA;AA+HN;AA9HM;EAGI,mBAAA;AA8HV;AAxHA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AA0HF;AAxHE;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;AA0HJ;AAvHE;EACE,mBAAA;AAyHJ;AAvHE;EACE,mBAAA;AAyHJ;AArHA;EACE,iBAAA;EACA,kBAAA;AAuHF;AArHE;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAuHJ;AArHI;EACE,eAAA;AAuHN;AApHI;EACE,cAAA;AAsHN;AAnHI;EACE,kBAAA;AAqHN;AAlHI;EACE,mBAAA;AAoHN;AAjHI;EACE,mBAAA;AAmHN;AA9GA;EACE,WAAA;EACA,YAAA;AAgHF;AA5GA;EACE,UAAA;EACA,eAAA;EACA,4BAAA;EACA,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mDAAA;EACA,cAAA;EACA,sBAAA;AA8GF;AA1GA;EACE,UAAA;EACA,eAAA;EACA,4BAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AA4GF;AAzGA;EACE,iCAAA;AA2GF;AAxGA;EAEE;IACE,iBAAA;EAyGF;EAnGA;IAEE,kBAAA;IACA,YAAA;EAoGF;EAhGA;IACE,cAAA;EAkGF;AACF;AA5FA;EACE;IACE,mBAAA;IACA,6BAAA;EA8FF;EA5FA;IACE,UAAA;IACA,aAAA;IACA,eAAA;EA8FF;EA5FA;IACE,eAAA;EA8FF;EA3FA;IACE,eAAA;IACA,WAAA;EA6FF;EAzFA;IACE,cAAA;EA2FF;AACF;AAxFA;EACE;IACE,UAAA;IACA,aAAA;IACA,eAAA;EA0FF;EAxFA;IACE,eAAA;EA0FF;EAvFA;IACE,eAAA;IACA,WAAA;EAyFF;AACF;AAnFA;EACE,SAAA;AAqFF;AAlFA;EACE,cAAA;AAoFF;AAjFA;EACE,cAAA;AAmFF;AAhFA;EACE,cAAA;AAkFF;AA/EA;EACE,kBAAA;EACA,iBAAA;AAiFF;AA3EG;EACO,gCAAA;AA6EV;AAzEG;EACO,gCAAA;AA2EV;AAvEI;EACM,kBAAA;EACA,0BAAA;AAyEV;AApEA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAsEF;AApEE;EACE,mBAAA;AAsEJ;AAnEE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAqEJ;AAnEI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAqEN;AAhEA;EACE,YAAA;EACA,uBAAA;EACA,YAAA;AAkEF;AA/DA;EACE,kBAAA;AAiEF;AA7DA;EACE,YAAA;EACA,iBAAA;AA+DF;AA5DA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AA8DF;AA3DA;EACE,+BAAA;AA6DF;AF1cI;EEkZA;IACE,sBAAA;EA2DJ;EAxDM;IACE,mBAAA;EA0DR;EApDA;IACE,kBAAA;EAsDF;EAjDA;IFvZE,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IE0ZA,eAAA;IACA,sBAAA;IACA,WAAA;IACA,WAAA;EAsDF;EAlDA;IACE,cAAA;IACA,WAAA;EAoDF;EAjDE;IAEE,gBAAA;IACA,iBAAA;IACA,cAAA;EAkDJ;EAhDI;IACE,YAAA;EAkDN;EA9CI;IACE,qBAAA;EAgDN;EA/BA;IACE,oBAAA;EAiCF;EA9BA;IACE,YAAA;IACA,oBAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;EAgCF;EA7BA;IF/cE,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IEidA,cAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;EAmCF;EAhCA;IACE,SAAA;EAkCF;EAhCE;IACE,mBAAA;IACA,uBAAA;EAkCJ;EAhCI;IACE,kBAAA;EAkCN;EA7BA;IACE,eAAA;EA+BF;EA5BA;IACE,cAAA;IACA,kBAAA;IAEA,gCAAA;IAEA,eAAA;EA4BF;EAzBA;IACE,WAAA;IACA,gBAAA;IACA,WAAA;EA2BF;EAxBA;IACE,WAAA;EA0BF;EAvBA;IACE,WAAA;EAyBF;AACF;;AArBA;EACE;IACE,mBAAA;IACA,6BAAA;IACA,gBAAA;IACA,mBAAA;EAwBF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.manage-inventory {\n  \n  margin-bottom: 40px;\n  padding-left: 100px !important;\n  // margin-right: 25px;\n \n  .alert{\n    border-radius: 8px;\n}\n.alert div:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n  .mediaStop{\n    height:140px;\n    width:251px;\n    margin-bottom: 20px;\n    }\n\n    .accordion {\n      border-bottom: 1px solid color(default, darker);\n      margin-bottom: 60px;\n    }\n\n  .ctn-alert {\n    .alert {\n      margin: 0 30px 30px;\n    }\n  }\n  \n  .not-eligible-container {\n    @include vendor-prefix('border-radius', 8px);\n    background: color(default, light);\n    border: 1px solid color(default, dark);\n    width: calc(33.33% - 14px);\n    margin-bottom: 20px;\n\n    .bottom-container {\n      @include vendor-prefix('border-radius', 0 0 8px 8px);\n      background-color: color(default, base);\n      border-top: 1px solid color(default, dark);\n      padding: 20px;\n      width: 100%;\n    }\n    .top-container {\n      padding: 20px;\n    }\n  }\n\n  @include respond-to(small) {\n\n    .accordion {\n      margin-bottom: 30px;\n    }\n\n    .not-eligible-container {\n      width: 100%;    \n    }\n    .fans-list{\n      .fans-list-container {\n        margin: 0 20px 20px 0!important;\n  }\n    }\n  }\n  h1 {\n    margin: 32px 0;\n    font-size: 40px;\n    font-family: 'Omnes-ATT-W02-Light';\n    @include respond-to(small) {\n      font-size: 25px;\n    }\n  }\n  h2 {\n    margin: 32px 0;\n    font-family: 'Omnes-ATT-W02' !important;\n  }\n  //for changing font size for h2 tag. \n  .fontsize{\n    font-size: 30px !important;\n  }\n\n  @include respond-to(small) {\n\n  h1 {\n    margin: 25px 0;\n    margin-top: 70px;\n  }\n}\n\n  .alert {\n    margin: -10px 0 30px;\n\n    .close {\n      cursor: pointer;\n    }\n  }\n\n  .panel {\n    min-height: 280px;\n    padding: 20px 0;\n    position: relative;\n  }\n\n\n.page-error {\n  margin-top: 20px;\n}\n\n.flex-container {\n  //@include vendor-prefix('flex-direction', row);\n // @include vendor-prefix('align-items', center);\n  border-right: 1px solid color(default, dark);\n  display: -webkit-flex;\n  display: flex;\n  float: left;\n}\n\n\n\n.nav-container-inventory {\n  @include vendor-prefix('transform', translateY(-50%));\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  width: calc(100% - 471px);\n}\n\n.link-button {\n  font-family: 'Omnes-ATT-W02';\n}\n.chart-container {\n  // margin: 0 20px;\n  text-align: center;\n}\n\n.chart-legend-container {\n  margin-left: 15px;\n  width: 250px;\n // margin-bottom: 20px;\n // border: 1px solid;\n}\n\n.cancel-participation-link {\n  padding-top: 14px;\n  text-align: center;\n}\n\n.chart-legends {\n  margin-left: 15px;\n  width: 250px;\n\n    .legend-container {\n      margin-top: 0;\n      li{\n          // box-shadow: 0 2px #ebebeb;\n          // margin-right: 36px;\n          padding-bottom: 3px;\n          // width: 200px;\n      }\n    }\n  \n}\n.apple-cert {\n  margin-right: 48px;\n  margin-top: -2px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  min-height: 82px;\n \n  i {\n    display: table-cell;\n    font-size: 25px;\n    padding-right: 5px;\n  }\n\n  a {\n    display: table-cell;\n  }\n  .icon-alert {\n    padding-right: 10px;\n  }\n}\n\n.nav-icons {\n  margin-left: 96px;\n  margin-right: 96px;\n\n  li {\n    display: inline-block;\n    text-align: center;\n    vertical-align: top;\n    width: calc(50% - 58px);\n\n    i {\n      font-size: 50px;\n    }\n\n    figure {\n      margin: 10px 0;\n    }\n\n    &:nth-child(odd) {\n      margin-right: 74px;\n    }\n\n    &:nth-child(1) {\n      margin-bottom: 20px;\n    }\n\n    &:nth-child(2) {\n      margin-bottom: 20px;\n    }\n  }\n}\n\nimg{\n  width: 50px;\n  height: 50px;\n}\n\n\n.addAccountBtn{\n  width: 89%;\n  margin-top: 13%;\n  padding: 10px 16px 10px 20px;\n  font: 16px 'Omnes-ATT-W02', Arial;\n  background-color: #0670B7;\n  border: 1px solid #d2d2d2;\n  border-radius: 8px;\n  box-shadow: 0px 5px 5px #0000000F;\n  color: #FCFCFC;\n  letter-spacing: 0.53px;\n\n}\n\n.addAccountBtnDisabled{\n  width: 89%;\n  margin-top: 13%;\n  padding: 10px 16px 10px 20px;\n  font: 16px 'Omnes-ATT-W02', Arial;\n  border: 1px solid #d2d2d2;\n  border-radius: 8px;\n  box-shadow: 0px 5px 5px #0000000F;\n  letter-spacing: 0.53px;\n  background: #d2d2d2;\n  cursor: not-allowed;\n  color: #767676;\n}\n\n.removeAccount {\n  font: 16px 'Omnes-ATT-W02', Arial;\n}\n\n@media screen and (min-width: 1025px) {\n\n  .cancel-participation-link {\n    margin-right: 10%;\n  }\n  // .legend-container {\n  //   margin-left: 10px;\n  // }\n\n  li{\n    // box-shadow: 0 2px #ebebeb;\n    margin-right: 36px;\n    width: 220px;\n  \n  }\n\n  .chart-container {\n    margin: 0 20px;\n  }\n\n\n}\n\n\n@media screen and (max-width: 1025px) and (min-width: 300px)  {\n  .manage-inventory {\n    margin-bottom: 40px;\n    padding-left: 11px !important;\n}\n  .addAccountBtn{\n    width: 98%;\n    margin-top: 0; \n    margin-left: 1%;\n    }\n  .cancel-participation-link {\n    margin-left: 1%;\n  }\n\n  li{\n    margin-left: 1%;\n    width: 100%;\n    // font-size: 12px 'ATT Aleck Sans';\n  }\n\n  .chart-container {\n    margin: 0 20px;\n  }\n}\n\n@media screen and (max-width: 300px)   {\n  .addAccountBtn{\n    width: 98%;\n    margin-top: 0; \n    margin-left: 1%;\n    }\n  .cancel-participation-link {\n    margin-left: 1%;\n  }\n\n  li{\n    margin-left: 1%;\n    width: 100%;\n  }\n\n}\n\n\n\n.iconNI, .iconE, .iconP, .iconI {\n  margin: 0;\n}\n\n.iconNI {\n  color: #ffb81e;\n}\n\n.iconE {\n  color: #cf2a2a;\n}\n\n.iconP, .iconI {\n  color: #007a3e;\n}\n\n.component-container {\n  margin-right: -1px;\n  padding-top: 20px;\n}\n\n\n.fans-list {\n   &:nth-child(2n) {\n   .fans-list-container {\n          margin: 0 20px 20px 0!important;\n    }\n   }\n   &:nth-child(1n) {\n   .fans-list-container {\n          margin: 0 20px 20px 0!important;\n    }\n   }\n  &:nth-child(3n) {\n    .fans-list-container {\n          margin: 0 20px 0 0 ;\n          margin-right: 0!important;\n    }\n  }\n}\n\n.search-fans {\n  float: right;\n  padding-left: 0;\n  padding-right: 0;\n  position: relative;\n  width: calc(33.33% - 10px);\n\n  input {\n    padding-right: 40px;\n  }\n\n  .search-icon {\n    margin-top: -10px;\n    position: absolute;\n    right: 5px;\n    top: 50%;\n\n    i {\n      color: color(default, darker);\n      cursor: pointer;\n      font-size: 25px;\n      font-weight: bold;\n      margin-right: 3px;\n      margin-top: -2px;\n    }\n  }\n}\n\n.pagination-position {\n  margin: auto;\n  padding: 10px 10px 20px;\n  width: 640px;\n}\n\n.search-input {\n  position: relative;\n\n}\n\n.clear-search {\n  float: right;\n  padding-top: 10px;\n}\n\n.no-result {\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #d1d1d1;\n  float: left;\n  margin: 0 20px 20px 0;\n  /* min-height: 355px; */\n  padding: 20px;\n  position: relative;\n  display: block;\n  width: calc(33.33% - 14px);\n}\n\n.disable-link{\n  pointer-events: none !important;\n}\n\n@include respond-to(small) {\n  \n    .alert {\n      margin: -10px 0px 20px;\n\n      div {\n        &:nth-child(2) {\n          padding-right: 30px;\n        }\n      }\n    }\n  \n\n  .panel {\n    padding: 20px 10px;\n  }\n\n  \n\n  .flex-container {\n    @include vendor-prefix('flex-direction', column);\n  \n    border-right: 0;\n    flex-direction: column;\n    float: none;\n    width: 100%;\n  }\n  \n\n  .chart-legend-container {\n    margin-left: 0;\n    width: 100%;\n    \n\n    .legend-container {\n      // margin-left: 10px;\n      min-height: auto;\n      margin-bottom: 6%;\n      margin-top: 6%;\n\n      ul {\n        margin: auto;\n        // max-width: 300px;\n      }\n\n      li {\n        display: inline-block;\n        // width: 130px;\n\n        &:nth-child(odd) {\n          // margin-right: 25px;\n          // max-width: calc(50% - 25px);\n          // margin-left: 25%;\n        }\n\n        &:nth-child(even) {\n          // margin-left: 10%;\n        }\n\n      }\n    }\n  }\n\n  .cancel-participation-link {\n    padding-bottom: 20px;\n  }\n\n  .apple-cert {\n    margin: auto;\n    padding-bottom: 20px;\n    padding-top: 0px;\n    width: 260px;\n    min-height: 69px;\n  }\n\n  .nav-container-inventory {\n    @include vendor-prefix('transform', none);\n    display: block;\n    padding-top: 20px;\n    position: relative;\n    width: 100%;\n  }\n\n  .nav-icons {\n    margin: 0;\n\n    li {\n      vertical-align: top;\n      width: calc(50% - 39px);\n\n      &:nth-child(odd) {\n        margin-right: 40px;\n      }\n    }\n  }\n\n  .component-container {\n    margin-right: 0;\n  }\n\n  .cancel-participation-link {\n    display: block;\n    text-align: center;\n    // border-top: 1px solid color(default, dark); \n    border-bottom: 1px solid color(default, dark);\n    // margin: 0 20px;\n    padding: 20px 0;\n  }\n\n  .search-fans {\n    float: none;\n    margin-top: 20px;\n    width: auto;\n  }\n\n  .clear-search {\n    float: none;\n  }\n\n  .pagination-position {\n    width: auto;\n  }\n}\n}\n\n@media screen and (max-width: 1025px) and (min-width: 300px)  {\n  .manage-inventory {\n    margin-bottom: 40px;\n    padding-left: 11px !important;\n    margin-top: 40px;\n    padding-right: 30px;\n}}\n\n// @media (min-width: 700px) {\n//   .manage-inventory {\n//     margin-bottom: 40px;\n//     padding-left: 11px !important;\n//     margin-top: 40px;\n//     padding-right: 93px;\n// }\n// }\n\n \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
